<div class="position-static response-summary">
  <button type="button" class="toast-close-button h-100 p-2" aria-label="Close" *ngIf="countOfMessages > 1" (click)="this.clear$.next(true)">
    <span aria-hidden="true">&times;</span>
  </button>
  <ng-container *ngIf="errors() | groupByValues: '$group' as grouped">
    <app-api-response *ngFor="let messages of grouped" [message]="messages[0]" [count]="messages.length" type="toast-error" (remove)="tryRemove(messages)"></app-api-response>
  </ng-container>
  <ng-container *ngIf="warnings() | groupByValues: '$group' as grouped">
    <app-api-response *ngFor="let messages of grouped" [message]="messages[0]" [count]="messages.length" type="toast-warning" (remove)="tryRemove(messages)"></app-api-response>
  </ng-container>
  <ng-container *ngIf="informations() | groupByValues: '$group' as grouped">
    <app-api-response *ngFor="let messages of grouped" [message]="messages[0]" [count]="messages.length" type="toast-info" (remove)="tryRemove(messages)"></app-api-response>
  </ng-container>
</div>
